import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id: string) => {
    setIsMenuOpen(false);
    
    // If not on home page, navigate to home first
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const element = document.getElementById(id);
      element?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTop = () => {
    setIsMenuOpen(false);
    
    if (location.pathname !== "/") {
      navigate("/");
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <>
      <header className="relative z-50 h-14 md:h-[60px] flex items-center justify-between md:justify-center bg-white border-b border-neutral-200 px-4 md:px-6">
        {/* Logo/Brand - visible on mobile */}
        <div className="md:hidden text-base font-light text-neutral-900" style={{ fontFamily: 'Inter, sans-serif' }}>
          August Labs
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center justify-center gap-6 text-sm font-light" style={{ fontFamily: 'Inter, sans-serif' }}>
          <button
            onClick={scrollToTop}
            className="text-neutral-500 hover:opacity-80 transition-opacity min-h-[44px] flex items-center"
          >
            Home
          </button>
          <span className="text-neutral-500">•</span>
          <Link
            to="/leadership"
            className="text-neutral-500 hover:opacity-80 transition-opacity min-h-[44px] flex items-center"
          >
            Leadership
          </Link>
          <span className="text-neutral-500">•</span>
          <Link
            to="/blog"
            className="text-neutral-500 hover:opacity-80 transition-opacity min-h-[44px] flex items-center"
          >
            Blog
          </Link>
          <span className="text-neutral-500">•</span>
          <button
            onClick={() => scrollToSection("contact")}
            className="text-[#cc0000] hover:opacity-80 transition-opacity min-h-[44px] flex items-center"
          >
            Get Started
          </button>
          <span className="text-neutral-500">•</span>
          <Link
            to="/support"
            className="text-neutral-500 hover:opacity-80 transition-opacity min-h-[44px] flex items-center"
          >
            Support
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden p-2 text-neutral-900 hover:text-[#cc0000] transition-colors"
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </header>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      {/* Mobile Menu Slide-in */}
      <div
        className={`fixed top-14 right-0 bottom-0 w-64 bg-white z-50 transform transition-transform duration-300 ease-in-out md:hidden ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <nav className="flex flex-col p-6 space-y-6" style={{ fontFamily: 'Inter, sans-serif' }}>
          <button
            onClick={scrollToTop}
            className="text-left text-lg font-light text-neutral-700 hover:text-[#cc0000] transition-colors py-3 border-b border-neutral-200"
          >
            Home
          </button>
          <Link
            to="/leadership"
            className="text-left text-lg font-light text-neutral-700 hover:text-[#cc0000] transition-colors py-3 border-b border-neutral-200"
            onClick={() => setIsMenuOpen(false)}
          >
            Leadership
          </Link>
          <Link
            to="/blog"
            className="text-left text-lg font-light text-neutral-700 hover:text-[#cc0000] transition-colors py-3 border-b border-neutral-200"
            onClick={() => setIsMenuOpen(false)}
          >
            Blog
          </Link>
          <button
            onClick={() => scrollToSection("contact")}
            className="text-left text-lg font-light text-[#cc0000] hover:opacity-80 transition-opacity py-3 border-b border-neutral-200"
          >
            Get Started
          </button>
          <Link
            to="/support"
            className="text-left text-lg font-light text-neutral-700 hover:text-[#cc0000] transition-colors py-3 border-b border-neutral-200"
            onClick={() => setIsMenuOpen(false)}
          >
            Support
          </Link>
        </nav>
      </div>
    </>
  );
}